"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UpArrowIcon = function UpArrowIcon(props) {
  var className = props.className,
      otherProps = _objectWithoutProperties(props, ["className"]);

  var iconClass = (0, _classnames.default)(_defineProperty({
    'hw-icon-up-arrow': true
  }, className, className));
  return _react.default.createElement(_Icon.default, _extends({
    viewBox: "0 0 24 24",
    className: iconClass
  }, otherProps), _react.default.createElement("path", {
    d: "M21.2 20L12 10.1 2.8 20 0 17 12 4l12 13"
  }));
};

UpArrowIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = UpArrowIcon;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Icon/icons/UpArrowIcon.js